import React from 'react';
import { Typography, Button, Paper } from '@mui/material';
import { ErrorOutline, Refresh } from '@mui/icons-material';

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  message = 'Произошла ошибка при загрузке данных',
  onRetry,
}) => {
  return (
    <Paper
      sx={{
        p: 3,
        m: 2,
        textAlign: 'center',
        bgcolor: 'error.dark',
        color: 'error.contrastText',
      }}
    >
      <ErrorOutline sx={{ fontSize: 48, mb: 2, opacity: 0.8 }} />
      <Typography variant="h6" gutterBottom>
        Ошибка
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
        {message}
      </Typography>
      {onRetry && (
        <Button
          variant="contained"
          color="primary"
          startIcon={<Refresh />}
          onClick={onRetry}
        >
          Повторить
        </Button>
      )}
    </Paper>
  );
};
